import enhancer from './enhancers'
import AccountVerificationSuccess from './AccountVerificationSuccess'

export default enhancer(AccountVerificationSuccess)
